import { put, debounce, select } from 'redux-saga/effects';
import * as filtersActions from '../actions/filters';
import * as offersActions from '../actions/offers';

function* updateFilterFieldsSaga() {
  const filters = yield select(state => state.Executorship.Offers.filters);
  let countFilters = 0;
  if (filters.search && filters.search.length > 1) {
    countFilters++;
  }
  if (filters.fields) {
    countFilters += Object.keys(filters.fields).length;
  }
  if (filters.count !== countFilters) {
    yield put(filtersActions.countFiltersOffers(countFilters));
  }
  if (countFilters > 0) {
    yield put(offersActions.getFilterOffers(filters));
  } else {
    yield put(offersActions.getAllOffers());
  }
}

export function* filtersConfigWatcher() {
  yield debounce(
    600,
    [
      filtersActions.updateFilterFieldsOffers.toString(),
      filtersActions.searchOffers.toString(),
    ],
    updateFilterFieldsSaga
  );
}
